exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expando {\n  width: 110px;\n  height: 35px;\n  border-radius: 3px;\n  border: solid 1px #e6e6e6;\n  background-color: #ffffff;\n  line-height: 1.69;\n  letter-spacing: normal;\n  color: var(--dark);\n}\n\n\n.expando svg {\n    margin-left: 5px;\n}", ""]);
